export default "__VITE_ASSET__LVZa$3WF__"